import React from "react";

import { SimpleAreaChart, StackedAreaChart } from "../Echarts";
import CircularProgress from "@material-ui/core/CircularProgress";
import PainelCard from "../../../../Cards/PainelCard";

import {
  PainelSec,
  PainelContainer,
  PainelWrapper,
  ExceptionText,
} from "./styles";

import { retornaNomeDoEstadoPelaUF } from "../../../../../utils/functions/PainelPage/format";
import { useAxios } from "../../../../../hooks/useAxios";

import { formataNumeroComPontos } from "../../../../../utils/functions/format";

export function AreaChartSession({ queryState }) {
  const [dados, setDados] = React.useState([]);

  let uri = `/total_obitos/?uf=${queryState}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  React.useEffect(() => {
    if (response) {
      for (let index = 0; index < response.dados.length; index++) {
        response.dados[index].mes =
          "" + response.dados[index].mes + "/" + response.dados[index].ano;
      }
      setDados(response.dados);
    }
  }, [response]);

  return (
    <PainelSec>
      <PainelWrapper>
        {loading && (
          <PainelContainer>
            <PainelCard>
              <CircularProgress style={{ margin: "auto" }} color={"primary"} />
            </PainelCard>
            <PainelCard>
              <CircularProgress style={{ margin: "auto" }} color={"primary"} />
            </PainelCard>
          </PainelContainer>
        )}


        {response && response.dados.length > 0 && dados && (

          <PainelContainer>
            <PainelCard
              cabecalho="Nº de óbitos por covid-19 confirmados"
              descricao={`No <strong>${retornaNomeDoEstadoPelaUF(
                queryState
              )}</strong>, 
                    até o ano de <strong>${
                      response.descricao_dados.notificacao_mais_recente
                    }</strong>, 
                    foram registrados <strong>${formataNumeroComPontos(
                      response.descricao_dados.total_obitos_nao_prof
                    )}</strong>
                    óbitos por covid-19 entre os que não são profissionais da saúde e 
                    <strong>${formataNumeroComPontos(
                      response.descricao_dados.total_obitos_prof
                    )}</strong> entre os que são profissionais
                    da saúde. Ao todo, foram registrados 
                    <strong>
                    ${formataNumeroComPontos(
                      parseInt(
                        response.descricao_dados.total_obitos_nao_prof +
                          response.descricao_dados.total_obitos_prof
                      )
                    )}
                    </strong> óbitos para covid-19.`}
            >

              <StackedAreaChart data={dados} />

            </PainelCard>

            <PainelCard
              cabecalho="Porcentagem de óbitos por covid-19 entre profissionais da saúde"
              descricao={`No <strong>${retornaNomeDoEstadoPelaUF(
                queryState
              )}</strong>, até o ano
                    de <strong>${
                      response.descricao_dados.notificacao_mais_recente
                    }</strong>, do total de 
                    óbitos por covid-19 notificados, foi constatado um percentual de
                    <strong>${
                      response.descricao_dados.total_porcent_obitos_prof + "%"
                    }</strong>
                    de óbitos somente de profissionais da saúde, com média de
                    <strong>${formataNumeroComPontos(
                      parseInt(response.descricao_dados.media_obitos_prof_mes)
                    )}</strong>
                    óbitos por mês.`}
            >

              <SimpleAreaChart data={dados} />

            </PainelCard>
          </PainelContainer>
        )}

        {(error || response?.dados.length === 0) && (
          <PainelContainer>
            <PainelCard>
              <ExceptionText>
                Não vai ser possível carregar os gráficos. {error}
              </ExceptionText>
            </PainelCard>
            <PainelCard>
              <ExceptionText>
                Não vai ser possível carregar os gráficos. {error}
              </ExceptionText>
            </PainelCard>
          </PainelContainer>
        )}
      </PainelWrapper>
    </PainelSec>
  );
}
